module.exports = __webpack_public_path__ + "static/media/review_bg.9b19c2a8.svg";